module.exports = __webpack_public_path__ + "static/media/fi-sr-chart-histogram.7c7dfb09.svg";